export const REMOVE_SNACKBAR = 'REMOVE_SNACKBAR';
export const ENQUEUE_SNACKBAR = 'ENQUEUE_SNACKBAR';
